import axios from '@/services/api'

const state = {
  selfie: {}
}

const mutations = {
  SET_SELFIE: (state, value) => {
    console.log('Inside SET_SELFIE - value', value)
    state.selfie = value
  }
}

const getters = {
  GET_SELFIE: (state) => state.selfie
}

const actions = {
  async GET_SELFIE_INFOS (app, payload) {
    try {
      // Get selfie user + photos labelled

      const selfieId = payload.selfieId
      const eventId = payload.eventId
      console.log('Inside GET_SELFIE_INFOS - selfie, eventId', selfieId, eventId)

      console.log('Inside GET_SELFIE_INFOS - app, token, axios ', app, selfieId, axios)
      const responseSelfie = await axios.get('/selfie/' + selfieId)
      console.log('Inside GET_SELFIE_INFOS - responseSelfie', responseSelfie)
      const selfie = responseSelfie.data.selfie
      const user = responseSelfie.data.user

      // if (selfie.event.slug !== eventId) {
      //  return 'Selfie does not belong to this event'
      // } else {
      app.commit('login/SET_USER', user, { root: true })
      app.commit('SET_SELFIE', selfie)
      return ''
      // }
    } catch (error) {
      console.log('window.location.path', window.location)
      app.commit('SET_SELFIE', {})
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
